import CourtIcon from "@mui/icons-material/AccountBalanceRounded";
import { Stack, Typography } from "@mui/material";

import { CourtInfo } from "@/pages/court-hearings/CourtHearings.utils";
import { useTranslation } from "@/translations";

interface Props {
  court: CourtInfo;
  /** 2 = primary group with a rule underneath, 3 = sub-group inside a day. */
  level: 2 | 3;
  id?: string;
}

/**
 * Court icon, court name and its short code (Kürzel) as a group heading; "Kein Gericht zugeordnet"
 * without one. The short code carries the "Gericht-Nr." label the report design calls for.
 */
export function CourtGroupHeading({ court, level, id }: Props) {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={level === 2 ? { pb: 1, borderBottom: 1, borderColor: "divider" } : undefined}
    >
      <CourtIcon color="action" fontSize="small" aria-hidden />
      <Typography
        id={id}
        variant={level === 2 ? "h4" : "subtitle1"}
        component={level === 2 ? "h2" : "h3"}
        fontWeight={700}
      >
        {court.courtName ?? t("courtHearings.report.noCourt")}
      </Typography>
      {court.courtShortCode && (
        <Typography variant="body2" color="text.secondary">
          {t("courtHearings.report.courtNumber", { shortCode: court.courtShortCode })}
        </Typography>
      )}
    </Stack>
  );
}
